import { render, staticRenderFns } from "./root-layout.vue?vue&type=template&id=0d265c66&scoped=true&"
import script from "./root-layout.vue?vue&type=script&lang=js&"
export * from "./root-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d265c66",
  null
  
)

export default component.exports